import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-red_star",
  "use": "icon-red_star-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-red_star\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 768l-174.250667 91.605333a42.666667 42.666667 0 0 1-61.909333-44.970666l33.28-194.048-141.013333-137.386667a42.666667 42.666667 0 0 1 23.68-72.832l194.816-28.288 87.125333-176.554667a42.666667 42.666667 0 0 1 76.544 0l87.125333 176.554667 194.816 28.288a42.666667 42.666667 0 0 1 23.68 72.789333l-141.013333 137.429334 33.28 194.048a42.666667 42.666667 0 0 1-61.866667 44.970666L512 768z\" fill=\"#A61D55\" p-id=\"5463\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/red_star.svg
// module id = V6P4
// module chunks = 8